export const LOAD_CIDADE_LOGADA = 'LOAD_CIDADE_LOGADA';
